import React from "react";
import Select from "react-select";
import { countrySelectStyles, getCountryCode } from "../utils/countryUtils";

/**
 * Composant champ pays réutilisable
 * @param {Object} props - Props du composant
 * @param {Array} props.countries - Liste des pays
 * @param {string} props.value - Valeur sélectionnée
 * @param {Function} props.onChange - Fonction appelée lors du changement
 * @param {string} props.label - Label du champ (par défaut "Pays")
 * @param {boolean} props.required - Si le champ est requis (par défaut true)
 * @param {string} props.placeholder - Placeholder du select
 * @param {Object} props.validationErrors - Erreurs de validation
 * @param {string} props.fieldName - Nom du champ pour les erreurs (par défaut "pays")
 * @param {boolean} props.isLoading - État de chargement
 */
const CountryField = ({
  countries = [],
  value,
  onChange,
  label = "Pays",
  required = true,
  placeholder = "Sélectionner un pays...",
  validationErrors = {},
  fieldName = "pays",
  isLoading = false,
  ...props
}) => {
  // La valeur reçue peut être un code (ex: "TG") ou un nom de pays
  // (ex: "Togo") selon l'API. On la résout en code pour sélectionner
  // l'option correspondante de façon fiable (insensible casse/accents).
  const resolvedCode = getCountryCode(value, countries);
  return (
    <div className="mb-4">
      <label className="block mb-2 text-sm font-medium text-gray-900">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <Select
        options={countries}
        value={
          countries.find((country) => country.value === resolvedCode) || null
        }
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={() => "Aucun résultat"}
        isClearable
        isSearchable
        isLoading={isLoading}
        styles={countrySelectStyles}
        {...props}
      />
      {validationErrors[fieldName] && (
        <p className="text-red-500 text-sm mt-1">
          {validationErrors[fieldName]}
        </p>
      )}
    </div>
  );
};

export default CountryField;
